class EyercloudConstants {
    static EXAM_CONSENT_TYPE = 'consent'
}

export default EyercloudConstants;
